import { CSSProperties, SVGProps } from "react";

/**
 * 属性存在优先级问题 1>2>3>4>5
 * 1 2 3 4 是根据Element元素默认优先级顺序
 * 定义：固有属性 < HTML属性 < CSS属性（class < style）
 * 固有属性：如svg默认为150*1
 * 5 为通过父级的class控制
 * TODO: 注意hover的使用情况
 * 如果使用hover改变图标的fill属性
 * 在foo.scss中可以直接通过 class名进行控制 { .search { :hover { .<className>/<tag(svg)> {fill: red} }}}}
 * 在style.module.scss, styleModule模式无效不起作用, 可以通过在styleModule中使用全局样式。
 * styleModule中的最佳实践 { :gloabl { .search { :hover { .<className>/<tag(svg)> {fill: red} }}} }
 */
export type SvgIconProps = {
  /**
   * icon名称，如：icon-keenote-foo
   */
  icon: string;
  /**
   * 同icon
   */
  children?: string;
  /**
   * style 优先级为1 行内样式 优先级要高于className
   */
  style?: CSSProperties;
  /**
   * className 优先等级为2 className优先级要高于attributes
   */
  className?: string;
  /**
   *  size 优先等级为3 提供简单的设置，控制icon的宽度和高度，注意此属性优先级高于attributes
   */
  width?: number | string;
  height?: number | string;
  /**
   * attributes 优先级为4 尽量使用attributes设置
   */
  attributes?: SVGProps<SVGSVGElement>;
};
const SvgIcon = (props: SvgIconProps) => {
  const {
    icon,
    attributes,
    children,
    className,
    style,
    width = "14",
    height = "14",
  } = props;

  let attribute = {
    fill: "currentcolor", // TODO: 方便设置svg的默认颜色，默认颜色使用当前字体的color
    ...attributes,
  };

  //   if (typeof size === "number") {
  attribute.height = height;
  attribute.width = width;
  attribute.viewBox = `0 0 ${width} ${height}`;
  //   }
  style && (attribute.style = style);
  className && (attribute.className = className);

  return (
    <svg {...attribute}>
      <use xlinkHref={"#" + (icon || children)} />
    </svg>
  );
};

export { SvgIcon };
